'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('regenerator-runtime/runtime.js');
require('@axa-fr/react-oidc');
var pathOr = require('ramda/src/pathOr');
var PropTypes = require('prop-types');
var React = require('react');
var axios = require('axios');
var reduxActions = require('redux-actions');
var shim = require('use-sync-external-store/shim');
var lodash = require('lodash');
var utilities = require('@module-federation/utilities');
var hoistNonReactStatics = require('hoist-non-react-statics');
var reactRedux = require('react-redux');
var invariant = require('invariant');
var isEmpty = require('lodash/isEmpty');
var isFunction = require('lodash/isFunction');
var isString = require('lodash/isString');
var conformsTo = require('lodash/conformsTo');
var isObject = require('lodash/isObject');
var isNumber = require('lodash/isNumber');
var toolkit = require('@reduxjs/toolkit');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var pathOr__default = /*#__PURE__*/_interopDefaultLegacy(pathOr);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var hoistNonReactStatics__default = /*#__PURE__*/_interopDefaultLegacy(hoistNonReactStatics);
var invariant__default = /*#__PURE__*/_interopDefaultLegacy(invariant);
var isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(isEmpty);
var isFunction__default = /*#__PURE__*/_interopDefaultLegacy(isFunction);
var isString__default = /*#__PURE__*/_interopDefaultLegacy(isString);
var conformsTo__default = /*#__PURE__*/_interopDefaultLegacy(conformsTo);
var isObject__default = /*#__PURE__*/_interopDefaultLegacy(isObject);
var isNumber__default = /*#__PURE__*/_interopDefaultLegacy(isNumber);

var getPath = function getPath(defaultPath) {
  var pathname = "".concat(window.location.pathname).concat(window.location.search).concat(window.location.hash);
  return pathname && pathname !== '/' ? pathname : defaultPath;
};
function logoutRedirect(userManager) {
  localStorage.setItem('userId', null);
  userManager.signoutRedirect();
}
function loginRedirect(userManager, defaultPath) {
  return userManager.signinRedirect({
    data: {
      path: getPath(defaultPath)
    }
  })
  // eslint-disable-next-line no-console
  ["catch"](function (error) {
    return console.warn('There has been an error with the OIDC Sign In Redirect', error);
  });
}

var setupOidcConfig = function setupOidcConfig(_ref) {
  var client_id = _ref.client_id,
    redirect_uri = _ref.redirect_uri,
    silent_redirect_uri = _ref.silent_redirect_uri,
    scope = _ref.scope,
    authority = _ref.authority,
    _ref$monitor_session = _ref.monitor_session,
    monitor_session = _ref$monitor_session === void 0 ? false : _ref$monitor_session,
    refresh_time_before_tokens_expiration_in_second = _ref.refresh_time_before_tokens_expiration_in_second,
    _ref$service_worker_r = _ref.service_worker_relative_url,
    service_worker_relative_url = _ref$service_worker_r === void 0 ? '/OidcServiceWorker.js' : _ref$service_worker_r,
    _ref$service_worker_o = _ref.service_worker_only,
    service_worker_only = _ref$service_worker_o === void 0 ? true : _ref$service_worker_o;
  if (refresh_time_before_tokens_expiration_in_second) {
    return {
      client_id: client_id,
      redirect_uri: redirect_uri,
      silent_redirect_uri: silent_redirect_uri,
      scope: scope,
      authority: authority,
      monitor_session: monitor_session,
      refresh_time_before_tokens_expiration_in_second: refresh_time_before_tokens_expiration_in_second,
      service_worker_relative_url: service_worker_relative_url,
      service_worker_only: service_worker_only
    };
  }
  return {
    client_id: client_id,
    redirect_uri: redirect_uri,
    silent_redirect_uri: silent_redirect_uri,
    scope: scope,
    authority: authority,
    monitor_session: monitor_session,
    service_worker_relative_url: service_worker_relative_url,
    service_worker_only: service_worker_only
  };
};

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var User$1 = /*#__PURE__*/_createClass(function User(name, email, subscriptions) {
  var claims = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var id = arguments.length > 4 ? arguments[4] : undefined;
  var contactFirmId = arguments.length > 5 ? arguments[5] : undefined;
  var firmType = arguments.length > 6 ? arguments[6] : undefined;
  var subscription_count_classic = arguments.length > 7 ? arguments[7] : undefined;
  var subscription_count_pro = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : "0";
  var roles = arguments.length > 9 ? arguments[9] : undefined;
  var preqinMaintenanceUserId = arguments.length > 10 ? arguments[10] : undefined;
  var preqinMaintenanceUserInitials = arguments.length > 11 ? arguments[11] : undefined;
  var preqinFirmId = arguments.length > 12 ? arguments[12] : undefined;
  var preqinFirmName = arguments.length > 13 ? arguments[13] : undefined;
  var preqin_firmCountry = arguments.length > 14 ? arguments[14] : undefined;
  _classCallCheck(this, User);
  this.name = name;
  this.email = email;
  this.subscriptions = subscriptions;
  this.claims = claims;
  this.id = id;
  this.contactFirmId = contactFirmId;
  this.firmType = firmType;
  this.internal = !!email.match(/preqin/gi);
  this.subscription_count_classic = subscription_count_classic;
  this.subscription_count_pro = subscription_count_pro;
  this.isFree = Number(subscription_count_pro) === 0;
  this.roles = roles;
  this.preqinMaintenanceUserId = preqinMaintenanceUserId;
  this.preqinMaintenanceUserInitials = preqinMaintenanceUserInitials;
  this.preqinFirmId = preqinFirmId;
  this.preqinFirmName = preqinFirmName;
  this.preqin_firmCountry = preqin_firmCountry;
});

var User = /*#__PURE__*/_createClass(function User(name, email, subscriptions) {
  var claims = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var id = arguments.length > 4 ? arguments[4] : undefined;
  var contactFirmId = arguments.length > 5 ? arguments[5] : undefined;
  var firmId = arguments.length > 6 ? arguments[6] : undefined;
  var firmName = arguments.length > 7 ? arguments[7] : undefined;
  var firmType = arguments.length > 8 ? arguments[8] : undefined;
  var preqinFirmType = arguments.length > 9 ? arguments[9] : undefined;
  var subscription_count_classic = arguments.length > 10 ? arguments[10] : undefined;
  var subscription_count_pro = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : "0";
  var purchasedPackage = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : {};
  var region = arguments.length > 13 ? arguments[13] : undefined;
  var preqin_firmCountry = arguments.length > 14 ? arguments[14] : undefined;
  _classCallCheck(this, User);
  this.name = name;
  this.email = email;
  this.subscriptions = subscriptions;
  this.claims = claims;
  this.id = id;
  this.contactFirmId = contactFirmId;
  this.firmId = firmId;
  this.firmName = firmName;
  this.firmType = firmType;
  this.internal = !!email.match(/preqin/gi);
  this.subscription_count_classic = subscription_count_classic;
  this.subscription_count_pro = subscription_count_pro;
  this.isFree = Number(subscription_count_pro) === 0;
  this.purchasedPackage = purchasedPackage;
  this.preqin_firmType = preqinFirmType;
  this.region = region;
  this.preqin_firmCountry = preqin_firmCountry;
});

//New Helper functions for New Package / Subs based users.
// Use only for when doing logical checks in the code for the user subs, otherwise please use the SubscriptionChecker Component also provided

// Category Access helper function - Checks the users category access from the purchased package and returns true / false
var hasCategoryAccess = function hasCategoryAccess(packageCategories, category) {
  var isCategoryArray = Array.isArray(category);
  var categories = packageCategories && packageCategories.map(function (item) {
    return item.toLowerCase();
  });
  var hasCategory;
  if (!isCategoryArray) {
    hasCategory = categories && categories.includes(category.toLowerCase());
  } else {
    hasCategory = category.length ? category.some(function (cat) {
      return hasCategoryAccess(packageCategories, cat);
    }) : true;
  }
  return hasCategory;
};

// Asset Class Access helper function - Checks the users asset class access from the purchased package and returns true / false
var hasAssetClassAccess = function hasAssetClassAccess(packageAssetClasses, assetClass) {
  var isAssetClassArray = Array.isArray(assetClass);
  var assetClasses = packageAssetClasses && Array.isArray(packageAssetClasses) ? packageAssetClasses.map(function (item) {
    return item.toLowerCase();
  }) : packageAssetClasses.toLowerCase();
  var hasAssetClass;
  if (!isAssetClassArray) {
    hasAssetClass = assetClasses && assetClasses.includes(assetClass.toLowerCase());
  } else {
    hasAssetClass = assetClass.length ? assetClass.some(function (ac) {
      return hasAssetClassAccess(packageAssetClasses, ac);
    }) : true;
  }
  return hasAssetClass;
};

// Add on Access helper function - Checks the users Add on access from the purchased package and returns true / false
var hasAddOnAccess = function hasAddOnAccess(packageAddons, addOn) {
  var isAddOnsArray = Array.isArray(addOn);
  var addOns = packageAddons && Array.isArray(packageAddons) ? packageAddons.map(function (item) {
    return item.toLowerCase();
  }) : packageAddons && packageAddons.toLowerCase();
  var hasAddOn;
  if (!isAddOnsArray) {
    hasAddOn = addOns && addOns.includes(addOn.toLowerCase());
  } else {
    hasAddOn = addOn.length ? addOn.some(function (ad) {
      return hasAddOnAccess(packageAddons, ad);
    }) : true;
  }
  return hasAddOn;
};

// Download Access helper function - Checks the users Download access from the purchased package and returns true / false for when its a string and not an array.
var hasDownloadAccessStringBased = function hasDownloadAccessStringBased(downloadType, download) {
  if (downloadType !== "nd") {
    return downloadType.includes(download.toLowerCase());
  }
  //if download type is no download user will not be allowed to download
  return !(downloadType && downloadType === "nd");
};

// Download Access helper function - Checks the users Download access from the purchased package and returns true / false
var hasDownloadAccess = function hasDownloadAccess(packageDownloadType, download) {
  var isDownloadArray = Array.isArray(download);
  var downloads = packageDownloadType && Array.isArray(packageDownloadType) ? packageDownloadType.map(function (item) {
    return item.toLowerCase();
  }) : packageDownloadType && packageDownloadType.toLowerCase();
  var hasDownload;
  if (!isDownloadArray) {
    hasDownload = downloads && hasDownloadAccessStringBased(downloads, download);
  } else {
    hasDownload = download.length ? download.some(function (ad) {
      return hasDownloadAccess(packageDownloadType, ad);
    }) : true;
  }
  return hasDownload;
};

//hasPackageAccess helper function - Checks the user package access and returns true/false
var hasPackageAccess = function hasPackageAccess(purchasedPackage, category, assetClass, addOn, download) {
  var categoryAccess = null;
  var assetClassAccess = null;
  var addOnAccess = null;
  var downloadAccess = null;
  if (category) {
    categoryAccess = purchasedPackage.categories && hasCategoryAccess(purchasedPackage.categories, category);
  }
  if (assetClass) {
    assetClassAccess = purchasedPackage.assetClasses && hasAssetClassAccess(purchasedPackage.assetClasses, assetClass);
  }
  if (addOn) {
    addOnAccess = purchasedPackage.addOns && hasAddOnAccess(purchasedPackage.addOns, addOn);
    return addOnAccess;
  }
  //check if user has download access for export
  if (download) {
    downloadAccess = hasDownloadAccess(purchasedPackage.downloadType, download);
    return downloadAccess;
  }
  if (category && assetClass) {
    return categoryAccess && assetClassAccess;
  } else if (category && !assetClass) {
    return categoryAccess;
  } else if (!category && assetClass) {
    return assetClassAccess;
  }
  return true;
};

// Use this function to check delivery mechanisms like: Pro, Feeds, Data API
function dependsOnDeliveryMechanism(deliveryMechanism, delivery, property) {
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return checkIfDeliveryMechanismHasDelivery(deliveryMechanism, delivery) ? property : defaultValue;
}
function checkIfDeliveryMechanismHasDelivery(deliveryMechanism, delivery) {
  if (!deliveryMechanism) {
    return false;
  }
  return Array.isArray(deliveryMechanism) ? deliveryMechanism.includes(delivery) : deliveryMechanism === delivery;
}
var downloadTypeForMultiplePackages = function downloadTypeForMultiplePackages() {
  var downloadType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (downloadType.includes("fd")) {
    return "fd";
  } else if (downloadType.includes("ld")) {
    return "ld";
  }
  return "nd";
};
var getUserFromAccessToken = function getUserFromAccessToken(accessToken, application) {
  var subscriptions = pathOr__default["default"]([], [_typeof(accessToken.preqin_subscription)], {
    string: [accessToken.preqin_subscription],
    array: accessToken.preqin_subscription,
    object: accessToken.preqin_subscription,
    undefined: []
  }).map(function (subscription) {
    return {
      id: subscription
    };
  });
  if (application === "pro") {
    var secAddOn = "sec";
    var deliveryMechanism = accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_deliverymechanism;
    var purchasedPackage = {
      name: accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_category,
      assetClasses: accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_assetclasses,
      addOns: accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_addons,
      downloadType: accessToken === null || accessToken === void 0 ? void 0 : accessToken.preqin_download
    };
    if (purchasedPackage.downloadType && Array.isArray(purchasedPackage.downloadType)) {
      var downloadType = purchasedPackage === null || purchasedPackage === void 0 ? void 0 : purchasedPackage.downloadType;
      // precedence for downloadType in case of multiple packages is -- fd,ld,nd
      purchasedPackage.downloadType = downloadTypeForMultiplePackages(downloadType);
    }

    //add sec as asset classes if sec is addon
    if (hasAddOnAccess(purchasedPackage.addOns, secAddOn)) {
      purchasedPackage.assetClasses = Array.isArray(purchasedPackage.assetClasses) ? [].concat(_toConsumableArray(purchasedPackage.assetClasses), [secAddOn]) : [purchasedPackage.assetClasses, secAddOn];
    }
    //geographies changes
    var decodedRegion = accessToken.preqin_geographies;
    var region = decodedRegion ? decodedRegion : ["geo_gl"];
    region = region && (Array.isArray(region) ? region : [region]);
    return new User(accessToken.preqin_userName, accessToken.name, subscriptions, undefined, accessToken.preqin_userId, accessToken.preqin_contactFirmId, accessToken.preqin_firmId, accessToken.preqin_firmName, accessToken.firmType, accessToken.preqin_firmType, accessToken.subscription_count_classic, accessToken.subscription_count_pro, dependsOnDeliveryMechanism(deliveryMechanism, "pro", purchasedPackage, {}), region, accessToken.preqin_firmCountry);
  }
  return new User$1(accessToken.preqin_userName, accessToken.name, subscriptions, undefined, accessToken.preqin_userId, accessToken.preqin_contactFirmId, accessToken.firmType, accessToken.subscription_count_classic, accessToken.subscription_count_pro, accessToken.preqin_role, accessToken.preqin_maintenance_userId, accessToken.preqin_maintenance_userInitials, accessToken.preqin_firmId, accessToken.preqin_firmName, accessToken.preqin_firmCountry);
};

//Selector to get feature state - string ("on"/"off")
//State is now redundant, it has been left in due to it being the first param passed in the function so it works with the old Split Integration.
var getFeatureToggleState = function getFeatureToggleState(state, feature) {
  if (window.splitClient) {
    return window.splitClient.getTreatment(feature);
  } else {
    return function (e) {
      throw e;
    }(new Error('SPLIT IO ERROR: window.splitClient is not set.'));
  }
};

//Selector to get feature state - object ({ treatment: "off", config: null})
//State is now redundant, it has been left in due to it being the first param passed in the function so it works with the old Split Integration.
var getFeatureToggleStateWithConfig = function getFeatureToggleStateWithConfig(state, feature) {
  if (window.splitClient) {
    return window.splitClient.getTreatmentWithConfig(feature);
  } else {
    return function (e) {
      throw e;
    }(new Error('SPLIT IO ERROR: window.splitClient is not set.'));
  }
};

var SubscriptionsChecker = function SubscriptionsChecker(_ref) {
  var purchasedPackage = _ref.purchasedPackage,
    accessCriteria = _ref.accessCriteria,
    noAccessFunction = _ref.noAccessFunction,
    noAccessComponent = _ref.noAccessComponent,
    children = _ref.children;
  //TODO: Double check Add Ons functions once its complete

  //TODO: Add in Geo check here

  if (!purchasedPackage) {
    return null;
  }
  var category = accessCriteria.category,
    assetClass = accessCriteria.assetClass,
    addOn = accessCriteria.addOn;

  // Category Access helper function - Checks the users category access from the purchased package and returns true / false
  var hasCategoryAccess = function hasCategoryAccess(packageCategories, category) {
    var isCategoryArray = Array.isArray(category);
    var categories = packageCategories && packageCategories.map(function (item) {
      return item.toLowerCase();
    });
    var hasCategory;
    if (!isCategoryArray) {
      hasCategory = categories && categories.includes(category.toLowerCase());
    } else {
      hasCategory = category.length ? category.some(function (cat) {
        return hasCategoryAccess(packageCategories, cat);
      }) : true;
    }
    return hasCategory;
  };

  // Asset Class Access helper function - Checks the users asset class access from the purchased package and returns true / false
  var hasAssetClassAccess = function hasAssetClassAccess(packageAssetClasses, assetClass) {
    var isAssetClassArray = Array.isArray(assetClass);
    var assetClasses = packageAssetClasses && Array.isArray(packageAssetClasses) ? packageAssetClasses.map(function (item) {
      return item.toLowerCase();
    }) : packageAssetClasses.toLowerCase();
    var hasAssetClass;
    if (!isAssetClassArray) {
      hasAssetClass = assetClasses && assetClasses.includes(assetClass.toLowerCase());
    } else {
      hasAssetClass = assetClass.length ? assetClass.some(function (ac) {
        return hasAssetClassAccess(packageAssetClasses, ac);
      }) : true;
    }
    return hasAssetClass;
  };

  // Add on Access helper function - Checks the users Add on access from the purchased package and returns true / false
  var hasAddOnAccess = function hasAddOnAccess(packageAddons, addOn) {
    var isAddOnsArray = Array.isArray(addOn);
    var addOns = packageAddons && Array.isArray(packageAddons) ? packageAddons.map(function (item) {
      return item.toLowerCase();
    }) : packageAddons && packageAddons.toLowerCase();
    var hasAddOn;
    if (!isAddOnsArray) {
      hasAddOn = addOns && addOns.includes(addOn.toLowerCase());
    } else {
      hasAddOn = addOn.length ? addOn.some(function (ad) {
        return hasAddOnAccess(packageAddons, ad);
      }) : true;
    }
    return hasAddOn;
  };

  //hasPackageAccess helper function - Checks the user package access and returns true/false
  var hasPackageAccess = function hasPackageAccess(purchasedPackage, category, assetClass, addOn) {
    var categoryAccess = null;
    var assetClassAccess = null;
    var addOnAccess = null;
    if (category) {
      categoryAccess = purchasedPackage.categories && hasCategoryAccess(purchasedPackage.categories, category);
    }
    if (assetClass) {
      assetClassAccess = purchasedPackage.assetClasses && hasAssetClassAccess(purchasedPackage.assetClasses, assetClass);
    }
    if (addOn) {
      addOnAccess = purchasedPackage.addOns && hasAddOnAccess(purchasedPackage.addOns, addOn);
      return addOnAccess;
    }
    if (category && assetClass) {
      return categoryAccess && assetClassAccess;
    } else if (category && !assetClass) {
      return categoryAccess;
    } else if (!category && assetClass) {
      return assetClassAccess;
    }
    return false;
  };
  if (hasPackageAccess(purchasedPackage, category, assetClass, addOn)) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
  }
  if (noAccessComponent) {
    noAccessFunction();
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, noAccessComponent);
  }
  noAccessFunction();
  return null;
};
SubscriptionsChecker.propTypes = {
  purchasedPackage: PropTypes__default["default"].shape({
    name: PropTypes__default["default"].string,
    access: PropTypes__default["default"].array,
    addOns: PropTypes__default["default"].array,
    assetClasses: PropTypes__default["default"].array,
    categories: PropTypes__default["default"].array
  }).isRequired,
  accessCriteria: PropTypes__default["default"].shape({
    assetClass: PropTypes__default["default"].oneOfType[(PropTypes__default["default"].string, PropTypes__default["default"].array)],
    category: PropTypes__default["default"].oneOfType[(PropTypes__default["default"].string, PropTypes__default["default"].array)]
  }).isRequired,
  children: PropTypes__default["default"].element
};
SubscriptionsChecker.defaultProps = {
  noAccessFunction: function noAccessFunction() {
    console.log("No Access hook function called - remember to set this function if required");
  }
};

function setTokenFromLocalStorage(IDENTITY_SERVER_URL, IDENTITY_SERVER_CLIENT, onSuccessFunction, onErrorFunction) {
  console.log('This function is deprecated and is no longer needed due to the new OIDC Service Worker. Please remove all references.');
  return null;
}
function setToken(token) {
  console.log('This function is deprecated and is no longer needed due to the new OIDC Service Worker. Please remove all references.');
  return null;
  // axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  // axios.defaults.headers.common['Cache-Control'] = 'no-cache';
  // axios.defaults.headers.common['Pragma'] = 'no-cache';
}

var request = function request(method, url, data, responseType) {
  return axios__default["default"]({
    method: method,
    url: url,
    data: data,
    responseType: responseType
  }).then(function (response) {
    return response;
  })["catch"](function (error) {
    console.error(error); // eslint-disable-line no-console
    return error.response;
  });
};
var get = function get(url) {
  return request('get', url);
};
var post = function post(url, payload) {
  return request('post', url, payload);
};
var put = function put(url, payload) {
  return request('put', url, payload);
};
var patch = function patch(url, payload) {
  return request('patch', url, payload);
};
var deleteData = function deleteData(url, payload) {
  return request('delete', url, payload);
};
var download = function download(url, payload) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
  return request(method, url, payload, 'blob');
};
var multipart = function multipart(url, payload) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
  return axios__default["default"][method](url, payload, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  }).then(function (response) {
    return response;
  })["catch"](function (error) {
    console.error(error); // eslint-disable-line no-console
    return error.response;
  });
};
var isSuccess = function isSuccess(response) {
  return response && response.data && response.status >= 200 && response.status < 300;
};

var CONNECT = 'CONNECT';
var CONNECTED = 'CONNECTED';
var DISCONNECT = 'DISCONNECT';
var DISCONNECTED = 'DISCONNECTED';
var INVOKE = 'INVOKE';
var ERROR = 'ERROR';
function action(type) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread2({
    type: type
  }, payload);
}

var WEBSOCKET_BASE = 'WEBSOCKET_';
var WEBSOCKET = {
  CONNECT: WEBSOCKET_BASE + CONNECT,
  CONNECTED: WEBSOCKET_BASE + CONNECTED,
  DISCONNECT: WEBSOCKET_BASE + DISCONNECT,
  DISCONNECTED: WEBSOCKET_BASE + DISCONNECTED,
  INVOKE: WEBSOCKET_BASE + INVOKE,
  ERROR: WEBSOCKET_BASE + ERROR
};

var websocket$1 = {
  connect: function connect(url) {
    return action(WEBSOCKET.CONNECT, {
      url: url
    });
  },
  connected: function connected(hubId) {
    return action(WEBSOCKET.CONNECTED, {
      hubId: hubId
    });
  },
  disconnect: function disconnect(url) {
    return action(WEBSOCKET.DISCONNECT, {
      url: url
    });
  },
  disconnected: function disconnected(hubId) {
    return action(WEBSOCKET.DISCONNECTED, {
      hubId: hubId
    });
  },
  invoke: function invoke(url, command, message) {
    return action(WEBSOCKET.INVOKE, {
      url: url,
      command: command,
      message: message
    });
  },
  error: function error(hubId, _error) {
    return action(WEBSOCKET.ERROR, {
      hubId: hubId,
      error: _error
    });
  }
};

// import { HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
var isIE = /*@cc_on!@*/!!document.documentMode;

// TODO: Write tests
// TODO: Undo IE11 fix once is no longer required

var signalRMiddleware = function signalRMiddleware(setListeners) {
  var hubConnections = [];
  var signalr = {};
  try {
    if (!isIE) {
      Promise.resolve().then(function () { return /*#__PURE__*/_interopNamespace(require('@microsoft/signalr')); }).then(function (module) {
        signalr = module;
      });
    }
  } catch (error) {
    console.error('Module @microsoft/signalr does not work with Internet Explorer');
  }
  var signalRStart = function signalRStart(dispatch, url, hubId, currentUser) {
    var hubConnection = hubConnections.find(function (x) {
      return x.baseUrl === url;
    });
    if (hubConnection) {
      hubConnection.stop();
    } else {
      hubConnection = new signalr.HubConnectionBuilder().withUrl(url).build();
      hubConnections.push(hubConnection);
    }

    // NOTE: At least one handler should be registered before connection.start().
    if (setListeners[hubId]) {
      setListeners[hubId](hubConnection, dispatch, currentUser);
    } else {
      console.error("WARNING: Websocket Hub ".concat(hubId, " has not set any listener")); // eslint-disable-line no-console
    }

    var start = function start() {
      return hubConnection.state === signalr.HubConnectionState.Disconnected && hubConnection.start().then(function () {
        return dispatch(websocket$1.connected(hubId));
      })["catch"](function (error) {
        dispatch(websocket$1.error(hubId, error.toString()));
        dispatch(websocket$1.disconnected(hubId));
        reconnect();
      });
    };
    var reconnect = function reconnect() {
      setTimeout(function () {
        return start();
      }, 10000);
    };
    start();
    hubConnection.onclose(function () {
      dispatch(websocket$1.disconnected(hubId));
      reconnect();
    });
  };
  var signalRStop = function signalRStop(dispatch, url, hubId) {
    var hubConnection = hubConnections.find(function (x) {
      return x.baseUrl === url;
    });
    if (hubConnection !== null) {
      hubConnection.stop().then(function () {
        return dispatch(websocket$1.disconnected(hubId));
      })["catch"](function (error) {
        return dispatch(websocket$1.error(hubId, error));
      });
    }
  };
  var signalRInvoke = function signalRInvoke(dispatch, url, hubId, command, message) {
    var hubConnection = hubConnections.find(function (x) {
      return x.baseUrl === url;
    });
    if (!hubConnection) {
      var errorMessage = 'SignalR Error: Invoke failed. HubConnection is null.';
      window.process.env.ENV_TYPE !== 'prod' && console.error(errorMessage); // eslint-disable-line no-console
      dispatch(websocket$1.error(hubId, errorMessage));
      return;
    }
    if (hubConnection.state !== signalr.HubConnectionState.Connected) {
      var _errorMessage = 'SignalR Error: Invoke failed. Connection status is not Conected.';
      window.process.env.ENV_TYPE !== 'prod' && console.error(_errorMessage); // eslint-disable-line no-console
      dispatch(websocket$1.error(hubId, _errorMessage));
      return;
    }
    hubConnection.invoke(command, message).then(function () {}) // Possible actions here
    ["catch"](function (error) {
      return dispatch(websocket$1.error(hubId, error));
    });
  };
  return function (store) {
    return function (next) {
      return function (action) {
        var dispatch = store.dispatch;
        var websockets = Object.values(store.getState().websocket);
        var index = websockets.indexOf(websockets.find(function (x) {
          return x.url === action.url;
        }));
        var hubId = Object.keys(store.getState().websocket)[index];
        var currentUser = store.getState().app.user;
        switch (action.type) {
          case WEBSOCKET.CONNECT:
            signalRStart(dispatch, action.url, hubId, currentUser);
            break;
          case WEBSOCKET.DISCONNECT:
            signalRStop(dispatch, action.url, hubId);
            break;
          case WEBSOCKET.INVOKE:
            signalRInvoke(dispatch, action.url, hubId, action.command, action.message);
            break;
          default:
            return next(action);
        }
      };
    };
  };
};

// eslint-disable-next-line import/no-anonymous-default-export
var signalR = (function (listeners) {
  return signalRMiddleware(listeners);
});

var HUBS = {
  NEWS_AGG: 'newsAgg',
  HF_PERFORMANCE: 'hfPerformance'
};

var _initialState, _handleActions;
var initialState = (_initialState = {}, _defineProperty(_initialState, HUBS.NEWS_AGG, {
  url: "".concat(window.process.env.NEWS_AGG_API_URL ? window.process.env.NEWS_AGG_API_URL : window._env_.NEWS_AGG_API_URL, "/aggregation-api/NewsAggEvents"),
  // TODO: This URL should be in config.js
  connected: null,
  error: null
}), _defineProperty(_initialState, HUBS.HF_PERFORMANCE, {
  url: "".concat(window.process.env.HF_EVENTS_URL ? window.process.env.HF_EVENTS_URL : window._env_.HF_EVENTS_URL),
  connected: null,
  error: null
}), _initialState);
function websocketConnected(state, _ref) {
  var hubId = _ref.hubId;
  return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, hubId, _objectSpread2(_objectSpread2({}, state[hubId]), {}, {
    connected: true
  })));
}
function websocketDisconnected(state, _ref2) {
  var hubId = _ref2.hubId;
  return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, hubId, _objectSpread2(_objectSpread2({}, state[hubId]), {}, {
    connected: false
  })));
}
function websocketError(state, _ref3) {
  var hubId = _ref3.hubId,
    error = _ref3.error;
  return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, hubId, _objectSpread2(_objectSpread2({}, state[hubId]), {}, {
    error: error
  })));
}
var websocket = reduxActions.handleActions((_handleActions = {}, _defineProperty(_handleActions, WEBSOCKET.CONNECTED, websocketConnected), _defineProperty(_handleActions, WEBSOCKET.DISCONNECTED, websocketDisconnected), _defineProperty(_handleActions, WEBSOCKET.ERROR, websocketError), _handleActions), initialState);

var useExternalStore = function useExternalStore(store, selector) {
  return shim.useSyncExternalStore(store.subscribe, React.useCallback(function () {
    return selector(store.getState(), [store, selector]);
  }));
};

var StoreKeySelector = function StoreKeySelector(key) {
  return React.useCallback(function (state) {
    return lodash.get(state, key);
  }, []);
};

var enableStoreSync = function enableStoreSync(appName, store) {
  return window["".concat(appName, "Store")] = store;
};

var importRemote = function importRemote(_ref) {
  var url = _ref.url,
    scope = _ref.scope,
    module = _ref.module;
  if (!url) {
    return console.error('ERROR @preqin/preqin-core - importRemote.js: URL is not defined, please pass the remote URL, e.g. https://master.app.mfe.subdomain.preqin.com');
  }
  if (!scope) {
    return console.error('ERROR @preqin/preqin-core - importRemote.js: SCOPE is not defined, please pass the scope of the Remote App (MFE), e.g. app_name' + ' This can be found in the Remote App (MFE) package.json, parameter "name"');
  }
  if (!module) {
    return console.error('ERROR @preqin/preqin-core - importRemote.js: MODULE is not defined, please pass the module of the Remote App (MFE), i.e. app_Name + App. e.g. app_NameApp' + 'The example is the standard naming format for Preqin.');
  }
  return utilities.importRemote({
    url: url,
    scope: scope,
    module: module
  });
};

var sanitiseHTMLTags = function sanitiseHTMLTags(string) {
  var allowedHTMLTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (typeof string !== 'string') {
    throw new Error('sanitiseHTMLTags: Input must be a string');
  }
  if (!Array.isArray(allowedHTMLTags)) {
    throw new Error('sanitiseHTMLTags: allowedHTMLTags must be an array of html tags');
  }
  var escapeRegex = function escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };
  var escapedTags = allowedHTMLTags.map(function (tag) {
    return escapeRegex(tag);
  });
  var allowedTagsRegex = allowedHTMLTags.length > 0 ? "<(?!/?(".concat(escapedTags.join('|'), ")s*/?>)[^>]*>") : '<[^>]*>';
  return string.replace(new RegExp(allowedTagsRegex, 'g'), '');
};

// const sanitizedString = sanitiseHTMLTags('<i>thing</i><a href="https://url.com">Link</a>', ['a', 'div']);

/**
 * Forces a reload of the injected reducers. i.e. Causes `createReducer` to be
 * called again with the injected reducers. Useful for hot-reloading.
 *
 * @param store The redux store that has been configured with
 *                  `createInjectorsEnhancer`
 * @example
 * forceReducerReload(store);
 *
 * @public
 */
function forceReducerReload(store) {
  store.replaceReducer(store.createReducer(store.injectedReducers));
}

/**
 * Validates the redux store is set up properly to work with this library.
 */
function checkStore(store) {
  var shape = {
    dispatch: isFunction__default["default"],
    subscribe: isFunction__default["default"],
    getState: isFunction__default["default"],
    replaceReducer: isFunction__default["default"],
    runSaga: isFunction__default["default"],
    createReducer: isFunction__default["default"],
    injectedReducers: isObject__default["default"],
    injectedSagas: isObject__default["default"]
  };
  invariant__default["default"](conformsTo__default["default"](store, shape), '(redux-injectors...) checkStore: Expected a redux store that has been configured for use with redux-injectors.');
}

var replaceInjectedReducers = function replaceInjectedReducers(rootReducers, keys, reducer) {
  var key = keys.shift();
  if (keys.length === 0) {
    rootReducers[key] = reducer;
    return;
  }
  if (rootReducers[key] === undefined) rootReducers[key] = {};
  var nextRootReducers = rootReducers[key];
  return replaceInjectedReducers(nextRootReducers, keys, reducer);
};
function injectReducerFactory(store, isValid) {
  return function injectReducer(key, reducer) {
    if (!isValid) checkStore(store);
    invariant__default["default"](isString__default["default"](key) && !isEmpty__default["default"](key) && isFunction__default["default"](reducer), "(preqin-core...) injectReducer: Expected `reducer` to be a reducer function");

    // Check `store.injectedReducers[key] === reducer` for hot reloading when a key is the same but a reducer is different
    if (Reflect.has(store.injectedReducers, key) && store.injectedReducers[key] === reducer) return;

    // ===> Original code
    // store.injectedReducers[key] = reducer;

    // ===> New code
    var keys = key.split(".");
    replaceInjectedReducers(store.injectedReducers, keys, reducer);
    store.replaceReducer(store.createReducer(store.injectedReducers));
  };
}
function getInjectors$1(store) {
  checkStore(store);
  return {
    injectReducer: injectReducerFactory(store, true)
  };
}

/**
 * A higher-order component that dynamically injects a reducer when the
 * component is instantiated
 *
 * @param {Object} params
 * @param {string} params.key The key to inject the reducer under
 * @param {function} params.reducer The reducer that will be injected
 *
 * @example
 *
 * class BooksManager extends React.PureComponent {
 *   render() {
 *     return null;
 *   }
 * }
 *
 * export default injectReducer({ key: "books", reducer: booksReducer })(BooksManager)
 *
 * @public
 */
var injectReducer = (function (_ref) {
  var key = _ref.key,
    reducer = _ref.reducer;
  return function (WrappedComponent) {
    var ReducerInjector = /*#__PURE__*/function (_React$Component) {
      _inherits(ReducerInjector, _React$Component);
      var _super = _createSuper(ReducerInjector);
      function ReducerInjector(props, context) {
        var _this;
        _classCallCheck(this, ReducerInjector);
        _this = _super.call(this, props, context);
        getInjectors$1(context.store).injectReducer(key, reducer);
        return _this;
      }
      _createClass(ReducerInjector, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/React__default["default"].createElement(WrappedComponent, this.props);
        }
      }]);
      return ReducerInjector;
    }(React__default["default"].Component);
    _defineProperty(ReducerInjector, "WrappedComponent", WrappedComponent);
    _defineProperty(ReducerInjector, "contextType", reactRedux.ReactReduxContext);
    _defineProperty(ReducerInjector, "displayName", "withReducer(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")"));
    return hoistNonReactStatics__default["default"](ReducerInjector, WrappedComponent);
  };
});

/**
 * A react hook that dynamically injects a reducer when the hook is run
 *
 * @param {Object} params
 * @param {string} params.key The key to inject the reducer under
 * @param {function} params.reducer The reducer that will be injected
 *
 * @example
 *
 * function BooksManager() {
 *   useInjectReducer({ key: "books", reducer: booksReducer })
 *
 *   return null;
 * }
 *
 * @returns {boolean} flag indicating whether or not the reducer has finished injecting
 * @public
 */
var useInjectReducer = function useInjectReducer(_ref2) {
  var key = _ref2.key,
    reducer = _ref2.reducer;
  var store = reactRedux.useStore();
  var _React$useState = React__default["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isInjected = _React$useState2[0],
    setIsInjected = _React$useState2[1];
  React__default["default"].useLayoutEffect(function () {
    getInjectors$1(store).injectReducer(key, reducer);
    setIsInjected(true);
  }, []);
  return isInjected;
};

var RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
var DAEMON = '@@saga-injector/daemon';
var ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';
var COUNTER = '@@saga-injector/counter';

/**
 * An enum of all the possible saga injection behaviours
 *
 * @property {String} RESTART_ON_REMOUNT The saga will be started on component instantiation and cancelled with
 * `task.cancel()` on component unmount for improved performance.
 * @property {String} DAEMON Causes the saga to be started on component instantiation and never canceled
 * or started again.
 * @property {String} ONCE_TILL_UNMOUNT Behaves like 'RESTART_ON_REMOUNT' but never runs it again.
 * @property {String} COUNTER Similar to 'RESTART_ON_REMOUNT' except the
 * saga will be mounted only once on first inject and ejected when all injectors are unmounted.
 * This enables you to have multiple injectors with the same saga and key and only one instance of the saga will run.
 *
 * @enum
 * @public
 */
var SagaInjectionModes = {
  RESTART_ON_REMOUNT: RESTART_ON_REMOUNT,
  DAEMON: DAEMON,
  ONCE_TILL_UNMOUNT: ONCE_TILL_UNMOUNT,
  COUNTER: COUNTER
};

var allowedModes = [RESTART_ON_REMOUNT, DAEMON, ONCE_TILL_UNMOUNT, COUNTER];
var checkKey = function checkKey(key) {
  return invariant__default["default"](isString__default["default"](key) && !isEmpty__default["default"](key), '(redux-injectors...) injectSaga: Expected `key` to be a non empty string');
};
var checkDescriptor = function checkDescriptor(descriptor) {
  var shape = {
    saga: isFunction__default["default"],
    mode: function mode(_mode) {
      return isString__default["default"](_mode) && allowedModes.includes(_mode);
    },
    count: isNumber__default["default"]
  };
  invariant__default["default"](conformsTo__default["default"](descriptor, shape), '(redux-injectors...) injectSaga: Expected a valid saga descriptor');
};
function injectSagaFactory(store, isValid) {
  return function injectSaga(key) {
    var descriptor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!isValid) checkStore(store);
    var newDescriptor = _objectSpread2(_objectSpread2({}, descriptor), {}, {
      mode: descriptor.mode || DAEMON,
      count: 0
    });
    var saga = newDescriptor.saga,
      mode = newDescriptor.mode;
    checkKey(key);
    checkDescriptor(newDescriptor);
    var hasSaga = Reflect.has(store.injectedSagas, key);
    if (process.env.NODE_ENV !== 'production') {
      var oldDescriptor = store.injectedSagas[key];
      // enable hot reloading of daemon and once-till-unmount sagas
      if (hasSaga && oldDescriptor.saga !== saga) {
        oldDescriptor.task.cancel();
        hasSaga = false;
      }
    }
    if (mode === COUNTER) {
      // COUNTER must be added if saga is done
      if (store.injectedSagas[key] === 'done') hasSaga = false;
      var oldCounterValue = 0;
      if (hasSaga) {
        oldCounterValue = Math.max(store.injectedSagas[key].count || 0, 0);
      }
      newDescriptor.count = oldCounterValue + 1;
    }
    if (!hasSaga || hasSaga && mode !== DAEMON && mode !== ONCE_TILL_UNMOUNT && mode !== COUNTER) {
      /* eslint-disable no-param-reassign */
      store.injectedSagas[key] = _objectSpread2(_objectSpread2({}, newDescriptor), {}, {
        task: store.runSaga(saga)
      });
      /* eslint-enable no-param-reassign */
    } else if (hasSaga && mode === COUNTER) {
      // increment num of sagas that wants to be injected
      /* eslint-disable no-param-reassign */
      store.injectedSagas[key].count = newDescriptor.count;
    }
  };
}
function ejectSagaFactory(store, isValid) {
  return function ejectSaga(key) {
    if (!isValid) checkStore(store);
    checkKey(key);
    if (Reflect.has(store.injectedSagas, key)) {
      var descriptor = store.injectedSagas[key];
      if (!descriptor.mode) {
        return;
      }
      if (descriptor.mode === COUNTER) {
        descriptor.count -= 1;
        if (descriptor.count > 0) return;
        descriptor.task.cancel();
        delete store.injectedSagas[key];
      } else if (descriptor.mode !== DAEMON) {
        descriptor.task.cancel();
        // Clean up in production; in development we need `descriptor.saga` for hot reloading
        if (process.env.NODE_ENV === 'production') {
          // Need some value to be able to detect `ONCE_TILL_UNMOUNT` sagas in `injectSaga`
          store.injectedSagas[key] = 'done'; // eslint-disable-line no-param-reassign
        }
      }
    }
  };
}

function getInjectors(store) {
  checkStore(store);
  return {
    injectSaga: injectSagaFactory(store, true),
    ejectSaga: ejectSagaFactory(store, true)
  };
}

/**
 * A higher-order component that dynamically injects a saga when the component
 * is instantiated. There are several possible "modes" / "behaviours" that
 * dictate how and when the saga should be injected and ejected
 *
 * @param {Object} params
 * @param {string} params.key The key to inject the saga under
 * @param {function} params.saga The saga that will be injected
 * @param {string} [params.mode] The injection behaviour to use. The default is
 * `SagaInjectionModes.DAEMON` which causes the saga to be started on component
 * instantiation and never canceled or started again. @see
 * {@link SagaInjectionModes} for the other possible modes.
 *
 * @example
 *
 * class BooksManager extends React.PureComponent {
 *  render() {
 *    return null;
 *  }
 * }
 *
 * export default injectSaga({ key: "books", saga: booksSaga })(BooksManager)
 *
 * @public
 *
 */
var injectSaga = (function (_ref) {
  var key = _ref.key,
    saga = _ref.saga,
    mode = _ref.mode;
  return function (WrappedComponent) {
    var InjectSaga = /*#__PURE__*/function (_React$Component) {
      _inherits(InjectSaga, _React$Component);
      var _super = _createSuper(InjectSaga);
      function InjectSaga(props, context) {
        var _this;
        _classCallCheck(this, InjectSaga);
        _this = _super.call(this, props, context);
        _this.injectors = getInjectors(context.store);
        _this.injectors.injectSaga(key, {
          saga: saga,
          mode: mode
        });
        return _this;
      }
      _createClass(InjectSaga, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.injectors.ejectSaga(key);
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React__default["default"].createElement(WrappedComponent, this.props);
        }
      }]);
      return InjectSaga;
    }(React__default["default"].Component);
    _defineProperty(InjectSaga, "WrappedComponent", WrappedComponent);
    _defineProperty(InjectSaga, "contextType", reactRedux.ReactReduxContext);
    _defineProperty(InjectSaga, "displayName", "withSaga(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")"));
    return hoistNonReactStatics__default["default"](InjectSaga, WrappedComponent);
  };
});

/**
 * A react hook that dynamically injects a saga when the hook is run
 *
 * @param {Object} params
 * @param {string} params.key The key to inject the saga under
 * @param {function} params.saga The saga that will be injected
 *
 * @example
 *
 * function BooksManager() {
 *   useInjectSaga({ key: "books", saga: booksSaga })
 *
 *   return null;
 * }
 *
 * @returns {boolean} flag indicating whether or not the saga has finished injecting
 * @public
 */
var useInjectSaga = function useInjectSaga(_ref2) {
  var key = _ref2.key,
    saga = _ref2.saga;
  var store = reactRedux.useStore();
  var _React$useState = React__default["default"].useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isInjected = _React$useState2[0],
    setIsInjected = _React$useState2[1];
  React__default["default"].useLayoutEffect(function () {
    getInjectors(store).injectSaga(key, {
      saga: saga,
      mode: SagaInjectionModes.COUNTER
    });
    setIsInjected(true);
    return function () {
      getInjectors(store).ejectSaga(key);
    };
  }, []);
  return isInjected;
};

/**
 * Creates a store enhancer that when applied will setup the store to allow the
 * injectors to work properly
 *
 * @param {Object} params
 * @param {function} params.runSaga A function that runs a saga. Should usually be `sagaMiddleware.run`
 * @param {function} params.createReducer A function that should create and
 * return the root reducer. It's passed the injected reducers as the first
 * parameter. These should be added to the root reducer using `combineReducer`
 * or a similar method.
 *
 * @example
 *
 * import { createStore } from "redux"
 * import { createInjectorsEnhancer } from "redux-injectors"
 *
 * function createReducer(injectedReducers = {}) {
 *  const rootReducer = combineReducers({
 *    ...injectedReducers,
 *    // other non-injected reducers can go here...
 *  });
 *
 *  return rootReducer
 * }
 * const runSaga = sagaMiddleware.run
 *
 * const store = createStore(
 *   createReducer(),
 *   initialState,
 *   createInjectorsEnhancer({
 *     createReducer,
 *     runSaga,
 *   })
 * )
 *
 * @public
 */
function createInjectorsEnhancer(params) {
  invariant__default["default"](conformsTo__default["default"](params, {
    runSaga: isFunction__default["default"],
    createReducer: isFunction__default["default"]
  }), '(redux-injectors...) createInjectorsEnhancer: params `runSaga` and ' + '`createReducer` are required.');
  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        createReducer: params.createReducer,
        runSaga: params.runSaga,
        injectedReducers: {},
        // Reducer registry
        injectedSagas: {} // Saga registry
      });
    };
  };
}

/**
 * Creates a "manager" component that will inject the provided reducer and saga
 * when mounted.  It only renders its children after both the reducer and saga
 * have been injected.  This is the recommended way to use redux-injectors.
 *
 * @param {Object} options
 * @param {string} options.name The name to give the manager that shows up in the react devtools
 * @param {string} options.key The key to inject the reducer under
 * @param {function} [options.reducer] The reducer that will be injected
 * @param {function} [options.saga] The saga that will be injected
 *
 * @example
 *
 * const BooksManager = createManager({ name: "BooksManager", key: "books", reducer: booksReducer, saga: booksSaga })
 *
 * @returns {ComponentType<{ children: ReactNode }>} The manager
 * @public
 */
function createManager(_ref) {
  var name = _ref.name,
    key = _ref.key,
    reducer = _ref.reducer,
    saga = _ref.saga;
  function Manager(props) {
    /* eslint-disable react-hooks/rules-of-hooks */

    var isReducerInjected = reducer ? useInjectReducer({
      key: key,
      reducer: reducer
    }) : true;
    var isSagaInjected = saga ? useInjectSaga({
      key: key,
      saga: saga
    }) : true;

    /* eslint-enable */

    return isReducerInjected && isSagaInjected ? props.children : null;
  }
  Manager.displayName = name;
  return Manager;
}

// NOTE: This file has been created on purpose and it is not included in https://github.com/react-boilerplate/redux-injectors

var combineInjectedReducers = function combineInjectedReducers(injectedReducers) {
  if (_typeof(injectedReducers) !== "object") return injectedReducers;
  var combineReducerObject = {};
  for (var prop in injectedReducers) {
    if (!injectedReducers.hasOwnProperty(prop)) continue;
    var value = injectedReducers[prop];
    if (_typeof(value) === "object") {
      combineReducerObject[prop] = combineInjectedReducers(value);
    } else if (typeof value === "function") {
      combineReducerObject[prop] = value;
    }
  }
  return toolkit.combineReducers(combineReducerObject);
};
var ReducerManager = /*#__PURE__*/_createClass(function ReducerManager(reducers) {
  var _this = this;
  _classCallCheck(this, ReducerManager);
  _defineProperty(this, "reducers", void 0);
  _defineProperty(this, "createReducer", function () {
    var injectedReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var newInjectedReducers = {};
    for (var key in injectedReducers) {
      if (!injectedReducers.hasOwnProperty(key)) continue;
      newInjectedReducers[key] = combineInjectedReducers(injectedReducers[key]);
    }
    return toolkit.combineReducers(_objectSpread2(_objectSpread2({}, _this.reducers), newInjectedReducers));
  });
  this.reducers = reducers;
});

exports.EnableStoreSync = enableStoreSync;
exports.HUBS = HUBS;
exports.ReducerManager = ReducerManager;
exports.SagaInjectionModes = SagaInjectionModes;
exports.StoreKeySelector = StoreKeySelector;
exports.SubscriptionChecker = SubscriptionsChecker;
exports.SyncExternalStore = useExternalStore;
exports.WEBSOCKET = WEBSOCKET;
exports.createInjectorsEnhancer = createInjectorsEnhancer;
exports.createManager = createManager;
exports.createSignalRMiddleware = signalR;
exports.deleteData = deleteData;
exports.download = download;
exports.forceReducerReload = forceReducerReload;
exports.get = get;
exports.getFeatureToggleState = getFeatureToggleState;
exports.getFeatureToggleStateWithConfig = getFeatureToggleStateWithConfig;
exports.getUserFromAccessToken = getUserFromAccessToken;
exports.hasAddOnAccess = hasAddOnAccess;
exports.hasAssetClassAccess = hasAssetClassAccess;
exports.hasCategoryAccess = hasCategoryAccess;
exports.hasDownloadAccess = hasDownloadAccess;
exports.hasPackageAccess = hasPackageAccess;
exports.importRemote = importRemote;
exports.injectReducer = injectReducer;
exports.injectSaga = injectSaga;
exports.isSuccess = isSuccess;
exports.loginRedirect = loginRedirect;
exports.logoutRedirect = logoutRedirect;
exports.multipart = multipart;
exports.patch = patch;
exports.post = post;
exports.put = put;
exports.sanitiseHTMLTags = sanitiseHTMLTags;
exports.setToken = setToken;
exports.setTokenFromLocalStorage = setTokenFromLocalStorage;
exports.setupOidcConfig = setupOidcConfig;
exports.useInjectReducer = useInjectReducer;
exports.useInjectSaga = useInjectSaga;
exports.websocketActions = websocket$1;
exports.websocketReducer = websocket;
